import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-top')) {
  // #page-topがあるページだけで実行
  page()
}

function page() {
  // TOPページの処理

  //  ###    ###  ##   ##
  //  ## #  # ##  ##   ##
  //  ##  ##  ##  ##   ##
  //  ##      ##   ## ##
  //  ##      ##    ###

  const topMvBg = document.getElementById('topMvBg')
  const topMvFront = document.getElementById('topMvFront')
  if (topMvBg && topMvFront) {
    // 背景・前面の2つのSwiperをControllerで同期（スワイプ時も連動）
    const swiperOptions = {
      effect: 'fade',
      speed: 500,
      loop: true,
      preloadImages: false,
      touchRatio: 0.3,
      fadeEffect: { crossFade: true },
    }
    const topMvBgSwiper = new Swiper(topMvBg, {
      ...swiperOptions,
      controller: { control: null },
    })
    const topMvFrontSwiper = new Swiper(topMvFront, {
      ...swiperOptions,
      controller: { control: topMvBgSwiper },
    })
    topMvBgSwiper.controller.control = topMvFrontSwiper

    // ラインアニメーション1ループ終了ごとに両方のSwiperを1つ進める
    const lineEl = document.querySelector('.js-slideAnime')
    if (lineEl) {
      lineEl.addEventListener('animationiteration', () => {
        topMvBgSwiper.slideNext()
      })
    }
  }

  //   ####    ###     ####  #####
  //  ##      ## ##   ##     ##
  //  ##     ##   ##   ###   #####
  //  ##     #######     ##  ##
  //   ####  ##   ##  ####   #####

  if (document.getElementById('topCase')) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars

    const sliderName = 'topCase'
    const slideItem = document.getElementById(sliderName)

    // 各要素を取得
    const slideWrap = slideItem.querySelector('.swiper-wrapper')
    const slideList = slideItem.querySelectorAll('.swiper-slide')
    let slideCount = slideList.length // スライドの数

    const slidePerViewMax = 0 * 3 // ループ表示に必要なスライド数　slidesPerViewの2倍
    // ループに不足するスライドを補充する
    while (slideCount < slidePerViewMax) {
      for (const iterator of slideList) {
        const clone = iterator.cloneNode(true)
        slideWrap.appendChild(clone)
        ++slideCount
      }
    }

    const topCaseSwiper = new Swiper(slideItem, {
      // init: false, // 自動で初期化しない（topCaseSwiper.init()で初期化）
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      // loopAdditionalSlides: 10, //ループ演出用のクローン数を増やして安定化させる
      preloadImages: false, // スライド内の画像を読み終えてから開始
      slidesPerView: 1.4, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
      spaceBetween: 16, //スライド同士の間隔を空ける

      touchRatio: 0.3, // タッチスワイプ感度（0でタッチスワイプ無効）

      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },
      breakpoints: {
        // 指定px以上でオプション切り替え
        769: {
          slidesPerView: 3.5, //表示数変更 小数指定可　'auto' + .swiper-slide
        },
      },
    })
  }
}
